export { default as CloseOutline } from "@ant-design/icons/lib/outline/CloseOutline";
export { default as CheckOutline } from "@ant-design/icons/lib/outline/CheckOutline";
